export const locale = {
  lang: 'id',
  data: {
    'LABEL': 'Tidak ada data',
  }
};
